'use client';
import React from 'react';
import Price from '@/components/price/Price';
import { useSelectedVariant } from '@/components/product/product-context';
import { useCampaign } from '@/app/CampaignContext';

const MicrositePdpPrice = ({ block, position }) => {
  const { variant } = useSelectedVariant();
  const campaign = useCampaign();
  const { uid, tag_text, microsite } = block?.microsite_pdp_price?.reference[0];

  return (
    <section id={`${uid}_${position}`} data-name={'pdp_price'}>
      <div className="mb-4 flex items-center gap-4">
        <Price
          price={variant.price}
          compareAtPrice={variant.compareAtPrice}
          priceClassOverride="price-l"
          crossedPriceClassOverride="price-l-crossed text-dawn-grey-60!"
          showSavings={true}
          darkPdp={true}
          pricingDetailsData={campaign.pricing_details}
          pricingDetailsClass={
            'text-dawn-grey-30 body-xs text-right pdp-price-details'
          }
          variant={`add-to-cart-${variant.handle}`}
          tagText={tag_text}
          microsite={microsite}
        />
      </div>
    </section>
  );
};

export default MicrositePdpPrice;
